import { render } from "./CrmPageHeader.vue?vue&type=template&id=97c8b506&scoped=true"
import script from "./CrmPageHeader.vue?vue&type=script&lang=js"
export * from "./CrmPageHeader.vue?vue&type=script&lang=js"

import "./CrmPageHeader.vue?vue&type=style&index=0&id=97c8b506&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97c8b506"]])

export default __exports__